import React, { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Row, Col, Card, Button, Form, Spinner } from "react-bootstrap";
import PageTitle from "../../Components/PageTitle";
import { useTranslation } from "react-i18next";
import FormInput from "../../Components/FormInput";
import { useNavigate, useParams } from "react-router-dom";
import { logout } from "../../redux/actions/AuthActions";
import { toast } from "react-toastify";
import Select from "react-dropdown-select";
import swal from 'sweetalert2';
import {
  getAllUsertypeUserList, getMasterBlockBookingList, getMasterDestinationList, getMasterHydrantList,
  getMasterSarpanchBookingList, getMasterSettings, getMasterVehicleList,getAllUsersRoleWiseList,
} from "../../redux/actions/MasterActions";
import { getHydrantListById } from "../../redux/actions/HydrantActions"
import { getDestinationListById } from "../../redux/actions/DestinationActions";
import { getScheduleBookingListById, saveScheduleBookingData, updateScheduleBookingData } from "../../redux/actions/ScheduleBookingActions";
import LeafletMap from "../../Components/LeafletMap";
import Preloader from "../../Components/Preloader";
import DatePicker from "react-datepicker";
import { setHours, setMinutes } from "date-fns";


const Dashboard = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const tableRef = useRef();
      const [roleCode,setroleCode]=useState("JUNIOR_ENGINEER");

  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    tanker_number: null,
    no_of_tanker: 1,
    hydrantLat: 0.00,
    hydrantLng: 0.00,
    destinationLat: 0.00,
    destinationLng: 0.00,
    booking_date: new Date(),
    totalDistance: 0
  })
  const dispatch = useDispatch();
  const {
    AuthReducer: { auth, loading, errors },
    masterReducer: {
      loadingMaster,
      errorsMaster,
      masterSettingsLists,
      masterHydrantLists,
      masterDestinationLists,
      masterSarpanchBookingLists,
      masterBlockBookingLists,
      masterUsertypeUserLists,
      masterUsersRoleWiseLists,
      masterVehicleLists,
    },
    hydrantReducer: {
      hydrantLists,
      loadingHydrant
    },
    destinationReducer: {
      destinationLists,
      loadingDestination,
    },
    scheduleBookingReducer: {
      changedScheduleBookingStatus,
      scheduleBookingLists,
      loadingScheduleBooking,
      errorsScheduleBooking,
    },
    userReducer: {
      userLists,
      loadingUser,
      errorsUser,
      changedUserStatus,
    },
  } = useSelector((state) => state);

  const [validated, setValidated] = useState(false);
  const [fieldErrors, setFieldErrors] = useState({});


  const [bookingDate, setBookingDate] = useState(
    setHours(setMinutes(new Date(), 0), 9),
  );
  useEffect(() => {
    if (auth?.accessToken && roleCode) {
      dispatch(getAllUsersRoleWiseList(auth?.accessToken, roleCode));
    }
  }, [auth?.accessToken, roleCode, dispatch]);

  useEffect(() => {
    if (auth?.accessToken && formData?.jenId) {
      dispatch(getMasterVehicleList(auth?.accessToken, formData?.jenId, ""));
      dispatch(getMasterHydrantList(auth?.accessToken, formData?.jenId));
      dispatch(getMasterDestinationList(auth?.accessToken, formData?.jenId));
    }
  }, [auth?.accessToken, formData?.jenId, dispatch]);

  const filterPassedTime = (time) => {
    const currentDate = new Date();
    const selectedDate = new Date(time);

    return currentDate.getTime() < selectedDate.getTime();
  };


  useEffect(() => {
    if (auth?.accessToken) {
      dispatch(getMasterSettings(auth?.accessToken));
      dispatch(getMasterBlockBookingList(auth?.accessToken));
      dispatch(getAllUsertypeUserList(auth?.accessToken, 13, ''));
      dispatch(getMasterSarpanchBookingList(auth?.accessToken))
    }
  }, [auth?.accessToken]);


  useEffect(() => {
    if (id) {
      dispatch(getScheduleBookingListById(auth?.accessToken, id));
    }
  }, [auth, id]);


  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
      event.stopPropagation();
    }
    setValidated(true);
    swal.fire({
      title: "Confirmation ?",
      text: `Total distance you have entered is ${formData.totalDistance}`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#28bb4b",
      cancelButtonColor: "#f34e4e",
      confirmButtonText: "Confirm my booking!",
    })
      .then((result) => {
        if (result.isConfirmed) {
          if (id) {
               const updatedpayload={
              id:id,
             jenId: formData?.jenId,
          mobile: formData?.mobile,
          name: formData?.name,
          altNumber: formData?.altNumber,
          bookingDate: formData?.bookingDate,
          bookingNumber:formData?.bookingNumber,
          vehicleNumber: formData?.vehicleNumber,
          hydrantId: formData?.hydrantId,
             hydrantName:formData?.hydrantName,
          destinationName:formData?.destinationName,
          destinationId: formData?.destinationId,
          hydrantLat: formData?.hydrantLat,
          hydrantLng: formData?.hydrantLng,
          destinationLat: formData?.destinationLat,
          destinationLng: formData?.destinationLng,
          totalDistance: Number(formData?.totalDistance),
          sarpanchId: formData?.sarpanchId,
          blockId: formData?.blockId,
          sunday:Number( formData?.sunday),
          monday:Number( formData?.monday),
          tuesday: Number(formData?.tuesday),
          wednesday: Number(formData?.wednesday),
          thursday: Number(formData?.thursday),
          friday: Number(formData?.friday),
          saturday: Number(formData?.saturday),
          status: formData?.status,
            }
            dispatch(updateScheduleBookingData(auth?.accessToken, updatedpayload, id));
          }
          else {
            const payload={
               

            jenId: formData?.jenId,
          mobile: formData?.mobile,
          name: formData?.name,
          altNumber: formData?.altNumber,
          bookingDate: formData?.bookingDate,
          bookingNumber:formData?.bookingNumber,
          vehicleNumber: formData?.vehicleNumber,
          hydrantId: formData?.hydrantId,
           hydrantName:formData?.hydrantName,
          destinationName:formData?.destinationName,
          destinationId: formData?.destinationId,
          hydrantLat: formData?.hydrantLat,
          hydrantLng: formData?.hydrantLng,
          destinationLat: formData?.destinationLat,
          destinationLng: formData?.destinationLng,
          totalDistance: Number(formData?.totalDistance),
          sarpanchId: formData?.sarpanchId,
          blockId: formData?.blockId,
          sunday:Number( formData?.sunday),
          monday:Number( formData?.monday),
          tuesday: Number(formData?.tuesday),
          wednesday: Number(formData?.wednesday),
          thursday: Number(formData?.thursday),
          friday: Number(formData?.friday),
          saturday: Number(formData?.saturday),
          status: formData?.status,
            }
            dispatch(saveScheduleBookingData(auth?.accessToken, payload));
          }
        }
      });
  };


  useEffect(() => {
    if (id) {
      if (scheduleBookingLists && Object.keys(scheduleBookingLists).length > 0) {
        setFormData({
                jenId: scheduleBookingLists?.jenId,
          mobile: scheduleBookingLists?.mobile,
          name: scheduleBookingLists?.name,
          altNumber: scheduleBookingLists?.altNumber,
          bookingDate: scheduleBookingLists?.bookingDate,
          bookingNumber:scheduleBookingLists?.bookingNumber,
          vehicleNumber: scheduleBookingLists?.vehicleNumber,
          hydrantId: scheduleBookingLists?.hydrantId,
          hydrantName:scheduleBookingLists?.hydrantName,
          destinationName:scheduleBookingLists?.destinationName,
          destinationId: scheduleBookingLists?.destinationId,
          hydrantLat: scheduleBookingLists?.hydrantLat,
          hydrantLng: scheduleBookingLists?.hydrantLng,
          destinationLat: scheduleBookingLists?.destinationLat,
          destinationLng: scheduleBookingLists?.destinationLng,
          totalDistance: scheduleBookingLists?.totalDistance,
          sarpanchId: scheduleBookingLists?.approval_one,
          blockId: scheduleBookingLists?.approvaltwo,
          sunday: scheduleBookingLists?.sunday,
          monday: scheduleBookingLists?.monday,
          tuesday: scheduleBookingLists?.tuesday,
          wednesday: scheduleBookingLists?.wednesday,
          thursday: scheduleBookingLists?.thursday,
          friday: scheduleBookingLists?.friday,
          saturday: scheduleBookingLists?.saturday,
          status: scheduleBookingLists?.status,
        });
      }
    }

  }, [scheduleBookingLists])


  useEffect(() => {
    if (errors) {
      if (errors?.status == 401) {
        dispatch(logout())
        toast.error(errors?.data?.message);
        window.location.reload();
      }
    }
  }, [errors])


  useEffect(() => {
    if (errorsScheduleBooking?.status == 409) {
      swal.fire({
        show: true,
        title: "Oops!",
        text: errorsScheduleBooking?.data?.message,
        icon: "error",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
    }
    else if (errorsScheduleBooking?.status == 400) {


        if (errorsScheduleBooking?.data?.errors && Array.isArray(errorsScheduleBooking.data.errors)) {
          const transformedErrors = {};
          errorsScheduleBooking.data.errors.forEach(error => {
            if (error.field && error.message) {
              transformedErrors[error.field] = error.message;
            }
          });
          setFieldErrors(transformedErrors);
        }else{
      dispatch({ type: 'RESET_DELETE_STATUS' });
        }
      }
  }, [errorsScheduleBooking])


  const inputHandler = (e) => {
    const { value, name } = e.target
    setFormData({ ...formData, [name]: value });
      if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      }
    );
    }
  }

  const inputHandlerNumeric = (e) => {
    const { value, name } = e.target;
    const processedValue = value
      .replace(/[^\d.]/g, '')
      .replace(/^(\d*\.?)|(\d*)\./g, '$1$2');

    setFormData({ ...formData, [name]: processedValue });
  };


  const inputHandlerMobile = (e) => {
    const { value, name } = e.target;
    let processedValue = value.replace(/\D/g, '');

    if (processedValue.length > 10) {
      processedValue = processedValue.slice(0, 10);
    }

    setFormData({ ...formData, [name]: processedValue });
    const isValidMobileNumber = /^([56789]\d{9})$/.test(processedValue);

    if (!isValidMobileNumber && processedValue.length == 10) {
      setFormData({ ...formData, [name]: "" });
      toast.error("Invalid mobile number!");
    }
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  const inputHandlerDays = (e) => {
    const { value, name } = e.target;
    let processedValue = value.replace(/\D/g, '');

    if (processedValue.length > 1) {
      processedValue = processedValue.slice(0, 1);
    }

    setFormData({ ...formData, [name]: processedValue });

     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  const inputHandlerCaps = (e) => {
    const { value, name } = e.target;
    const processedValue = value.replace(/\s+/g, '').toUpperCase();
    setFormData({ ...formData, [name]: processedValue });
 if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  const selectHandler = (selectedData, name) => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [name]: selectedData
    }));

    if (name === "jenId") {
      // These will be handled by useEffect when formData.jenId changes
    }
     if (fieldErrors?.[name]) {
      setFieldErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[name];
        return newErrors;
      });
    }
  };


  useEffect(() => {
    if (changedScheduleBookingStatus?.message) {
      swal.fire({
        show: true,
        title: "Well done!",
        text: changedScheduleBookingStatus.message,
        icon: "success",
        showConfirmButton: false,
        timer: 1500
      });
      dispatch({ type: 'RESET_DELETE_STATUS' });
      navigate(-1);
    }
  }, [changedScheduleBookingStatus,dispatch,navigate])


  const 
  
  
  customSelectStyles = {
    control: (base, state) => ({
      ...base,
      borderColor: errorsScheduleBooking?.data?.vehicle_model ? 'red' : base.borderColor,
      '&:hover': {
        borderColor: errorsScheduleBooking?.data?.vehicle_model ? 'red' : base.borderColor,
      }
    }),
  };


  const onDateChange = (name, value) => {
    if (value) {
      setFormData({ ...formData, [name]: value });
    }
  };


  useEffect(() => {
    setFormData({});
    dispatch({ type: 'RESET_DELETE_SCHEDULE_BOOKING_STATUS' });
  }, [dispatch]);


  useEffect(() => {
    //generateTankerOptions(masterSettingsLists.no_of_tanker)
  }, [masterSettingsLists])


  const generateTankerOptions = (noOfTankers) => {
    const options = [];
    for (let i = 1; i <= noOfTankers; i++) {
      options.push({ value: `${i}`, label: `${i} Tanker` });
    }
    return options;
  };


  useEffect(() => {
    dispatch(getHydrantListById(auth?.accessToken, formData?.hydrantId))
  }, [formData?.hydrantId])


  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      hydrantName: hydrantLists?.name ?? ' ',
      hydrantLat: hydrantLists?.latitude ?? '0.00',
      hydrantLng: hydrantLists?.longitude ?? '0.00',
      vehicleType: 'Tanker',
    }));
  }, [hydrantLists])


  useEffect(() => {
    dispatch(getDestinationListById(auth?.accessToken, formData?.destinationId))
  }, [formData?.destinationId])


  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      destinationName: destinationLists?.name ?? ' ',
      destinationLat: destinationLists?.latitude ?? '0.00',
      destinationLng: destinationLists?.longitude ?? '0.00'
    }));
  }, [destinationLists])


  useEffect(() => {
    setFormData({ ...formData, "bookingDate": bookingDate });
  }, [bookingDate])


  useEffect(()=>{
    setFieldErrors()
  },[navigate])


  return (
    <>
      <PageTitle
        breadCrumbItems={[
          { label: t("Booking"), path: "Add-Booking" },
          { label: (scheduleBookingLists && Object.keys(scheduleBookingLists).length > 0) ? t("Update Schedule Booking") : t("Add Schedule Booking"), path: "/Add-Booking", active: true },
        ]}
        title={(scheduleBookingLists && Object.keys(scheduleBookingLists).length > 0) ? t("Update Schedule Booking") : t("Add Schedule Booking")}
      />

      <Row>
        <Col lg={6}>
          <Card>
            <Card.Body>
              <div style={{ position: "relative", overflow: "hidden", height: "755px" }}>
                <LeafletMap
                  mapHeight={"755px"}
                  center={[formData.hydrantLat || 0.00, formData.hydrantLng || 0.00]}
                  zoom={15}
                  hydrantMarkerPosition={[formData.hydrantLat || 0.00, formData.hydrantLng || 0.00]}
                  destinationMarkerPosition={[formData.destinationLat || 0.00, formData.destinationLng || 0.00]}
                  setFormData={setFormData}
                />
              </div>
            </Card.Body>
          </Card>
        </Col>

        <Col lg={6}>
          <Card>
            <Card.Body>
              {errorsScheduleBooking?.data?.message && (
                <div className="alert alert-danger">
                  {errorsScheduleBooking.data.message}
                </div>
              )}

              <Row>
                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("J.E.N.")}</Form.Label>
                   <Select
                       options={masterUsersRoleWiseLists}
                     className={fieldErrors?.jenId ? "border-danger" : ""}
                       values={masterUsersRoleWiseLists?.filter(data => data?.id === formData?.jenId)}
                             name="jenId"
                           labelField={"name"}
                               valueField={"id"}
                                 onChange={(selectedData) => selectHandler(selectedData[0]?.id, "jenId")}
                               styles={customSelectStyles}
                                       />
                    {fieldErrors?.jenId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.jenId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Customer Mobile")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.mobile}
                    name="mobile"
                    onChange={inputHandlerMobile}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Customer Name")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.name}
                    name="name"
                    onChange={inputHandler}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Alt Number")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.altNumber}
                    name="altNumber"
                    onChange={inputHandlerMobile}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <div className="mb-3">
                    <label className="form-label">{t("Booking Time")}</label> <br />
                    <DatePicker
                      selected={bookingDate}
                      onChange={(date) => setBookingDate(date)}
                      showTimeSelect
                      className="form-control"
                      withPortal
                      minDate={new Date()}
                      maxDate={new Date(new Date().setDate(new Date().getDate() + 1))}
                      value={formData.bookingDate}
                      filterTime={filterPassedTime}
                      dateFormat="MMMM d, yyyy h:mm aa"
                    />
                    {fieldErrors?.vehicle_model && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.data?.vehicle_model}</p>
                      </div>
                    )}
                  </div>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Vehicle Number")}</Form.Label>
                    <Select
                       className={fieldErrors?.vehicleNumber ? "border-danger" : ""}
                      options={masterVehicleLists}
                      values={masterVehicleLists.filter((num) => num?.vehicleNumber === formData?.vehicleNumber)}
                      name="vehicleNumber"
                      labelField={"vehicleNumber"}
                      valueField={"vehicleId"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.vehicleNumber, "vehicleNumber")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.vehicleNumber && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.vehicleNumber}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Hydrant")}</Form.Label>
                    <Select
                       className={fieldErrors?.hydrantId ? "border-danger" : ""}
                      options={masterHydrantLists}
                      values={masterHydrantLists.filter((hyd) => hyd?.hydrantId === formData?.hydrantId)}
                      name="hydrantId"
                      labelField={"name"}
                      valueField={"hydrantId"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.hydrantId, "hydrantId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.hydrantId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.hydrantId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={6}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Destination")}</Form.Label>
                    <Select
                       className={fieldErrors?.destinationId ? "border-danger" : ""}
                      options={masterDestinationLists}
                      values={masterDestinationLists.filter((dest) => dest?.destinationId === formData?.destinationId)}
                      name="destinationId"
                      labelField={"name"}
                      valueField={"destinationId"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.destinationId, "destinationId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.destinationId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.destinationId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Hydrant Lat")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.hydrantLat}
                    name="hydrantLat"
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Hydrant Lng")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.hydrantLng}
                    name="hydrantLng"
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Destination Lat")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.destinationLat}
                    name="destinationLat"
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Destination Lng")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.destinationLng}
                    name="destinationLng"
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <FormInput
                    label={t("Distance")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.totalDistance}
                    name="totalDistance"
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Approval One")}</Form.Label>
                    <Select
                       className={fieldErrors?.sarpanchId ? "border-danger" : ""}
                      options={masterSarpanchBookingLists}
                      values={masterSarpanchBookingLists.filter((sar) => sar.id === formData.sarpanchId)}
                      name="sarpanchId"
                      labelField={"name"}
                      valueField={"id"}
                      onChange={(selectedData) => selectHandler(selectedData[0].id, "sarpanchId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.sarpanchId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.sarpanchId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={4}>
                  <Form.Group className="mb-3">
                    <Form.Label>{t("Approval Two")}</Form.Label>
                    <Select
                       className={fieldErrors?.blockId ? "border-danger" : ""}
                      options={masterBlockBookingLists}
                      values={masterBlockBookingLists.filter((bol) => bol.id === formData.blockId)}
                      name="blockId"
                      labelField={"name"}
                      valueField={"id"}
                      onChange={(selectedData) => selectHandler(selectedData[0]?.id, "blockId")}
                      styles={customSelectStyles}
                    />
                    {fieldErrors?.blockId && (
                      <div className="invalid-feedback d-block">
                        <p className="text-danger">{fieldErrors?.blockId}</p>
                      </div>
                    )}
                  </Form.Group>
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Sunday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.sunday}
                    name="sunday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Monday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.monday}
                    name="monday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Tuesday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.tuesday}
                    name="tuesday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Wednesday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.wednesday}
                    name="wednesday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Thursday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.thursday}
                    name="thursday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Friday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.friday}
                    name="friday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>

                <Col lg={3}>
                  <FormInput
                    label={t("Saturday")}
                    type="text"
                    errors={fieldErrors}
                    value={formData.saturday}
                    name="saturday"
                    onChange={inputHandlerDays}
                    containerClass={"mb-3"}
                  />
                </Col>
              </Row>

              {loading ?
                <>
                  <Button color="primary" disabled>
                    <Spinner
                      className="spinner-border-sm me-1"
                      tag="span"
                      color="white"
                    />
                    Please wait ...
                  </Button>
                </>
                :
                <>
                  <Button type="button" onClick={handleSubmit} disabled={loading}>
                    {(scheduleBookingLists && Object.keys(scheduleBookingLists).length > 0) ? t("Update") : t("Submit")}
                  </Button>
                </>
              }
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {loadingScheduleBooking && (<Preloader />)}
      {loadingDestination && (<Preloader />)}
      {loadingMaster && (<Preloader />)}
      {loadingUser && (<Preloader />)}
      {loadingHydrant && (<Preloader />)}
    </>
  );
};

export default Dashboard;
